<template>
    <div class="m-home">
        <y-slideshow
            v-if="mainSlideshowItems && mainSlideshowItems.length"
            :name="mainSlideshow.slug"
            :type="mainSlideshow.type"
            v-bind="mainSlideshow.props"
            class="m-home__slider"
        >
            <y-slide
                v-for="slide in mainSlideshowItems"
                :key="slide.id"
                :position="slide.position"
            >
                <component
                    :is="slideShowTag(slide.button_link)"
                    :to="slide.button_link || ''"
                    :href="slide.button_link"
                    :target="slideshowTarget(slide.button_link)"
                    rel="noopener noreferrer"
                >
                    <img
                        v-if="slide.image"
                        :src="slide.image.link"
                        class="m-home__slider__image"
                    >
                    <div class="m-home__slider__overlay" />

                    <div class="m-home__slider__content">
                        <h2
                            v-if="slide.title"
                            class="m-home__slider__title"
                        >
                            {{ slide.title }}
                        </h2>
                        <p
                            v-if="slide.title2"
                            class="m-home__slider__subtitle"
                        >
                            {{ slide.title2 }}
                        </p>
                    </div>
                </component>
            </y-slide>
        </y-slideshow>

        <y-container>
            <y-list-wrapper
                v-if="productscategoriesItems && productscategoriesItems.length"
                type="one-line"
                classes="m-home__products-category"
                limit="5"
                :component="{
                    name: 'YInfoBox',
                    type: 'Simple',
                    link: { name: 'products-category' },
                }"
                :items="productscategoriesItems"
            />

            <y-row>
                <y-col>
                    <y-section-title
                        type="standard"
                        :title="$t('home.discounted_products')"
                        :link="{ name: 'products-list', query: { has_discount: 1 }}"
                        :link-text="$t('home.all_discounts')"
                        class="m-home__title"
                        :has-icon="true"
                    />
                    <y-list-wrapper
                        v-if="discountlist && discountlist.length"
                        type="grid"
                        class="m-home__product-discount"
                        :component="{
                            classes : 'mt-5',
                            name : 'YProductCard',
                            type : 'Minimal',
                        }"
                        size="6"
                        :col="{
                            sm: '4',
                            md: '3',
                        }"
                        :items="discountlist"
                        :limit="discountlist.length"
                    />
                </y-col>
            </y-row>

            <y-card
                v-if="adsTop && adsTop.custom"
                :element="{
                    image:adsTop.image
                }"
                type="banner"
                :title="adsTop.title"
                :subtitle="adsTop.title2"
                :button-content="adsTop.custom.button_text"
                :to="{ path: adsTop.custom.button_link }"
                image-version="main"
                class="m-home__banner--top"
                button-color="primary"
                no-overlay
            />

            <y-row>
                <y-col
                    md="3"
                    class="m-home__banner--middle-right mt-15"
                >
                    <y-card
                        v-if="adsMiddleRight && adsMiddleRight.custom"
                        type="banner"
                        :element="{
                            image:adsMiddleRight.image
                        }"
                        image-version="square"
                        :color="adsMiddleRight.custom.color"
                        :tag="adsMiddleRight.custom.button_link.startsWith('http') ? 'a' : 'router-link'"
                        v-bind="{
                            to: adsMiddleRight.custom.button_link.startsWith('http') ? {} : adsMiddleRight.custom.button_link,
                            href: adsMiddleRight.custom.button_link.startsWith('http') ? adsMiddleRight.custom.button_link : undefined,
                        }"
                        :size="$mq | mq({ xs: 'normal', md: 'normal'})"
                        no-overlay
                    />
                </y-col>
                <y-col md="9">
                    <y-card
                        v-if="adsMiddleLeft && adsMiddleLeft.custom"
                        :element="{
                            image:adsMiddleLeft.image
                        }"
                        class="m-home__banner--middle mt-15"
                        type="banner"
                        image-version="medium"
                        :title="adsMiddleLeft.title"
                        :subtitle="adsMiddleLeft.title2"
                        :color="adsMiddleLeft.custom.color"
                        :tag="adsMiddleLeft.custom.button_link.startsWith('http') ? 'a' : 'router-link'"
                        v-bind="{
                            to: adsMiddleLeft.custom.button_link.startsWith('http') ? {} : adsMiddleLeft.custom.button_link,
                            href: adsMiddleLeft.custom.button_link.startsWith('http') ? adsMiddleLeft.custom.button_link : undefined,
                        }"
                        no-overlay
                    />
                </y-col>
            </y-row>

            <y-list-wrapper
                v-if="productscategoriesItemsBottom && productscategoriesItemsBottom.length"
                type="one-line"
                classes="m-home__products-category"
                limit="5"
                :component="{
                    name: 'YInfoBox',
                    type: 'Simple',
                    link: { name: 'products-category' },
                }"
                :items="productscategoriesItemsBottom"
            />

            <y-row>
                <y-col>
                    <y-section-title
                        type="standard"
                        :title="$t('home.bestsellers_products')"
                        :link="{ name: 'products-list' }"
                        :link-text="$t('home.all_products')"
                        class="m-home__title"
                        :has-icon="true"
                    />
                    <y-list-wrapper
                        v-if="bestsellers && bestsellers.length"
                        type="grid"
                        :component="{
                            classes : 'mt-5',
                            name : 'YProductCard',
                            type : 'Minimal',
                        }"
                        size="6"
                        :col="{
                            sm: '4',
                            md: '3',
                        }"
                        :items="bestsellers"
                        :limit="bestsellers.length"
                    />
                </y-col>
            </y-row>

            <y-row>
                <y-col>
                    <div v-if="salesFeatures && salesFeatures.length">
                        <y-section-title
                            type="standard"
                            :title="$t('home.feature_title')"
                            class="m-home__sales-feature__title"
                        />
                        <y-list-wrapper
                            type="grid"
                            limit="3"
                            class="m-home__sales-feature__item"
                            :component="{
                                name: 'YInfoBox',
                                type: 'Simple',
                                imageVersion: 'main'
                            }"
                            size="4"
                            :col="{
                                lg: 4,
                                md: 4,
                                xs: 12,
                            }"
                            :items="salesFeatures"
                            no-scroll
                        />
                    </div>
                </y-col>
            </y-row>

            <y-row>
                <y-col>
                    <y-section-title
                        type="standard"
                        :title="$t('home.blog')"
                        :link="{ name: 'blog-list' }"
                        :link-text="$t('home.all_posts')"
                        class="m-home__title mt-15"
                        has-icon
                    />
                    <y-list-wrapper
                        v-if="latestcontent && latestcontent.length"
                        type="grid"
                        class="m-home__blog"
                        :component="{
                            name : 'YBlogCard',
                            type : 'informed',
                            imageVersion: 'main'
                        }"
                        size="6"
                        :col="{
                            lg: 6,
                            md: 6,
                            xs: 12,
                        }"
                        limit="2"
                        :items="latestcontent"
                        no-scroll
                    />
                </y-col>
            </y-row>
        </y-container>
    </div>
</template>
<script>

    import { YSlide } from '@components';
    import {
        YSlideshow, YListWrapper, YSectionTitle,
    } from '@rogues';
    import PageMixin from '@nodes/mixins/Page';

    export default {
        name: 'HomePage',

        components: {
            YSlide,
            YSlideshow,
            YListWrapper,
            YSectionTitle,
        },

        mixins: [PageMixin],

        /**
         * @inheritDoc
         */
        data() {
            return {
                pageTitle       : this.$t('home.title'),
                emptySpecialSale: false,
                responsive      : {
                    slideButton: {
                        768: 'normal',
                    },
                },
                mainSlideshow: {
                    name : 'Main Slideshow',
                    slug : 'slideshow',
                    type : 'simple',
                    props: {
                        pagination    : 6,
                        paginationNoBg: true,
                    },
                },
                mainSlideshowItems           : [],
                productscategoriesItems      : [],
                discountlist                 : [],
                productbanner                : [],
                adsTop                       : [],
                adsMiddleRight               : [],
                adsMiddleLeft                : [],
                latestcontent                : [],
                bestsellers                  : [],
                salesFeatures                : [],
                productscategoriesItemsBottom: [],
            };
        },

        /**
         * @inheritdoc
         */

        methods: {
            /**
             * Return slideshow tag
             *
             * @param {string} url
             * @returns {string}
             */
            slideShowTag(url) {
                return url && this.isExternal(url) ? 'a' : 'router-link';
            },
            /**
             * Return target attribute of slideshow
             *
             * @param {string} url
             * @returns {string}
             */
            slideshowTarget(url) {
                return url && this.isExternal(url) ? '_blank' : '_self';
            },
            /**
             * if link contain http or not
             *
             * @param {string} url
             * @returns {boolean}
             */
            isExternal(url) {
                return url.startsWith('http');
            },
            /**
             * Fetch home data
             *
             * @returns {Promise}
             */
            fetch() {
                this.productsResponse = [];

                const slideshow = this.$services.ContentThemes.slideshowsList({
                    type  : 'slideshow',
                    locale: this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                const categories = this.$services.Tagging.labels({
                    slug     : 'products-category',
                    locale   : this.$i18n.locale,
                    including: ['image:img', 'title', 'parent_id', 'url_encode', 'slug'],
                }).catch((error) => {
                    this.handleError(error);
                });

                const discount = this.$services.Content.postList({
                    type        : 'products',
                    locale      : this.$i18n.locale,
                    including   : ['title', 'image', 'wares', 'ware_original_price', 'ware_sale_price', 'ware_is_available', 'url_encode', 'product_tagging_categories'],
                    limit       : 8,
                    has_discount: 1,
                }).catch((error) => {
                    this.handleError(error);
                });

                const adsTop = this.$services.Content.postSingle({
                    type     : 'ads',
                    slug     : 'banner-5',
                    locale   : this.$i18n.locale,
                    including: ['title', 'image', 'title2', 'slug', 'tagging_labels', 'custom'],
                }).catch((error) => {
                    if (error.response.status !== 404) {
                        this.handleError(error);
                    }
                });

                const adsMiddleRight = this.$services.Content.postSingle({
                    type     : 'ads',
                    slug     : 'banner-6',
                    locale   : this.$i18n.locale,
                    including: ['image', 'slug', 'tagging_labels', 'custom'],
                }).catch((error) => {
                    if (error.response.status !== 404) {
                        this.handleError(error);
                    }
                });

                const adsMiddleLeft = this.$services.Content.postSingle({
                    type     : 'ads',
                    slug     : 'banner-7',
                    locale   : this.$i18n.locale,
                    including: ['title', 'image', 'title2', 'slug', 'tagging_labels', 'custom'],
                }).catch((error) => {
                    if (error.response.status !== 404) {
                        this.handleError(error);
                    }
                });

                const bestsellers = this.$services.Content.postList({
                    type     : 'products',
                    locale   : this.$i18n.locale,
                    including: ['title', 'image', 'wares', 'ware_original_price', 'ware_sale_price', 'ware_is_available', 'url_encode', 'published_at', 'product_tagging_categories'],
                    sort     : 'sale_count',
                    limit    : 8,
                }).catch((error) => {
                    this.handleError(error);
                });

                const salesFeatures = this.$services.Content.postList({
                    type     : 'sales-features',
                    locale   : this.$i18n.locale,
                    including: ['title', 'image', 'custom'],
                }).catch((error) => {
                    this.handleError(error);
                });

                const content = this.$services.Content.postList({
                    type     : 'blog',
                    locale   : this.$i18n.locale,
                    including: ['id', 'title', 'image', 'synopsis', 'published_at', 'publisher', 'tagging_labels:tags', 'url_encode'],
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([slideshow, categories, discount, adsTop, adsMiddleRight, adsMiddleLeft, bestsellers, salesFeatures, content]).then((responses) => {
                    if (this.handleReq(responses, 0)) {
                        this.set(this.mainSlideshow, 'props', {
                            ...this.mainSlideshow.props,
                            effect       : responses[0].data.metadata.configs.effect,
                            loop         : !!responses[0].data.metadata.configs.loop,
                            autoplay     : !!responses[0].data.metadata.configs.autoplay,
                            direction    : responses[0].data.metadata.configs.direction,
                            slidesPerView: responses[0].data.metadata.configs.slides_per_view,
                            speed        : responses[0].data.metadata.configs.speed,
                            spaceBetween : parseInt(responses[0].data.metadata.configs.space_between, 10),
                        });
                        this.mainSlideshowItems = responses[0].data.results;
                    }
                    if (this.handleReq(responses, 1)) {
                        this.productscategoriesItems = responses[1].data.results.filter((item) => !item.parent_id);
                        this.productscategoriesItemsBottom = this.productscategoriesItems.splice(5, 5);
                    }
                    if (this.handleReq(responses, 2)) {
                        this.discountlist = responses[2].data.results.filter((item) => !item.parent_id);
                    }
                    if (this.handleReq(responses, 3)) {
                        this.adsTop = responses[3].data.results;
                    }
                    if (this.handleReq(responses, 4)) {
                        this.adsMiddleRight = responses[4].data.results;
                    }
                    if (this.handleReq(responses, 5)) {
                        this.adsMiddleLeft = responses[5].data.results;
                    }
                    if (this.handleReq(responses, 6)) {
                        this.bestsellers = responses[6].data.results;
                    }
                    if (this.handleReq(responses, 7)) {
                        this.salesFeatures = responses[7].data.results.map((post) => ({
                            ...post,
                            img : post.image,
                            link: post.custom.link ? post.custom.link : null,
                            tag : post.custom.link ? 'a' : 'div',
                        }));
                    }
                    if (this.handleReq(responses, 8)) {
                        this.latestcontent = responses[8].data.results;
                    }
                })
                    .catch((error) => {
                        this.handleError(error);
                    });
            },
        },

    };
</script>

<style lang="scss" src="../scss/home.scss"/>
